<template>
    <v-container fluid grid-list-xl>
        <div>
            <v-alert
                    id="alertComp"
                    v-model="alert"
                    dismissible
                    type="success"
            >
                Configuración guardada exitosamente.
            </v-alert>
        </div>
        <v-form ref="form" v-model="valid" lazy-validation>
            <h3 class="primary--text">Configuración Módulo COVID</h3>

            <v-layout wrap align-center>
                <v-flex xs12 sm11 md12 offset-sm1>
                    <p class="font-weight-bold">Configuración notificación alerta positiva</p>
                </v-flex>                
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 1">
                    <v-text-field
                            name="correo1"
                            label="Correo 1 Notificación Alerta COVID"
                            id="correo1"
                            :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 100) || 'El número de caracteres debe ser menor a 100']"
                            v-model="covidConfiguration.notificationEmailAlarm1"
                            required
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 1">
                    <v-select
                    v-model="covidConfiguration.companyAlarm1.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 1">
                    <v-text-field
                            name="correo2"
                            label="Correo 2 Notificación Alerta COVID"
                            id="correo2"
                            v-model="covidConfiguration.notificationEmailAlarm2"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 1">
                    <v-select
                    v-model="covidConfiguration.companyAlarm2.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 1">
                    <v-text-field
                            name="correo3"
                            label="Correo 3 Notificación Alerta COVID"
                            id="correo3"
                            v-model="covidConfiguration.notificationEmailAlarm3"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 1">
                    <v-select
                    v-model="covidConfiguration.companyAlarm3.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 1">
                    <v-text-field
                            name="correo4"
                            label="Correo 4 Notificación Alerta COVID"
                            id="correo4"
                            v-model="covidConfiguration.notificationEmailAlarm4"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 1">
                    <v-select
                    v-model="covidConfiguration.companyAlarm4.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 1">
                    <v-text-field
                            name="correo5"
                            label="Correo 5 Notificación Alerta COVID"
                            id="correo5"
                            v-model="covidConfiguration.notificationEmailAlarm5"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 1">
                    <v-select
                    v-model="covidConfiguration.companyAlarm5.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 2">
                    <v-text-field
                            name="correo6"
                            label="Correo 6 Notificación Alerta COVID"
                            id="correo6"
                            v-model="covidConfiguration.notificationEmailAlarm6"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 2">
                    <v-select
                    v-model="covidConfiguration.companyAlarm6.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 2">
                    <v-text-field
                            name="correo7"
                            label="Correo 7 Notificación Alerta COVID"
                            id="correo7"
                            v-model="covidConfiguration.notificationEmailAlarm7"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 2">
                    <v-select
                    v-model="covidConfiguration.companyAlarm7.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 2">
                    <v-text-field
                            name="correo8"
                            label="Correo 8 Notificación Alerta COVID"
                            id="correo8"
                            v-model="covidConfiguration.notificationEmailAlarm8"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 2">
                    <v-select
                    v-model="covidConfiguration.companyAlarm8.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 2">
                    <v-text-field
                            name="correo9"
                            label="Correo 9 Notificación Alerta COVID"
                            id="correo9"
                            v-model="covidConfiguration.notificationEmailAlarm9"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 2">
                    <v-select
                    v-model="covidConfiguration.companyAlarm9.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 2">
                    <v-text-field
                            name="correo10"
                            label="Correo 10 Notificación Alerta COVID"
                            id="correo10"
                            v-model="covidConfiguration.notificationEmailAlarm10"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 2">
                    <v-select
                    v-model="covidConfiguration.companyAlarm10.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 3">
                    <v-text-field
                            name="correo11"
                            label="Correo 11 Notificación Alerta COVID"
                            id="correo11"
                            v-model="covidConfiguration.notificationEmailAlarm11"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 3">
                    <v-select
                    v-model="covidConfiguration.companyAlarm11.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 3">
                    <v-text-field
                            name="correo12"
                            label="Correo 12 Notificación Alerta COVID"
                            id="correo12"
                            v-model="covidConfiguration.notificationEmailAlarm12"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 3">
                    <v-select
                    v-model="covidConfiguration.companyAlarm12.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 3">
                    <v-text-field
                            name="correo13"
                            label="Correo 13 Notificación Alerta COVID"
                            id="correo13"
                            v-model="covidConfiguration.notificationEmailAlarm13"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 3">
                    <v-select
                    v-model="covidConfiguration.companyAlarm13.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 3">
                    <v-text-field
                            name="correo14"
                            label="Correo 14 Notificación Alerta COVID"
                            id="correo14"
                            v-model="covidConfiguration.notificationEmailAlarm14"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 3">
                    <v-select
                    v-model="covidConfiguration.companyAlarm14.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 3">
                    <v-text-field
                            name="correo15"
                            label="Correo 15 Notificación Alerta COVID"
                            id="correo15"
                            v-model="covidConfiguration.notificationEmailAlarm15"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 3">
                    <v-select
                    v-model="covidConfiguration.companyAlarm15.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>            
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 4">
                    <v-text-field
                            name="correo16"
                            label="Correo 16 Notificación Alerta COVID"
                            id="correo16"
                            v-model="covidConfiguration.notificationEmailAlarm16"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 4">
                    <v-select
                    v-model="covidConfiguration.companyAlarm16.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 4">
                    <v-text-field
                            name="correo17"
                            label="Correo 17 Notificación Alerta COVID"
                            id="correo17"
                            v-model="covidConfiguration.notificationEmailAlarm17"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 4">
                    <v-select
                    v-model="covidConfiguration.companyAlarm17.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 4">
                    <v-text-field
                            name="correo18"
                            label="Correo 18 Notificación Alerta COVID"
                            id="correo18"
                            v-model="covidConfiguration.notificationEmailAlarm18"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 4">
                    <v-select
                    v-model="covidConfiguration.companyAlarm18.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 4">
                    <v-text-field
                            name="correo19"
                            label="Correo 19 Notificación Alerta COVID"
                            id="correo19"
                            v-model="covidConfiguration.notificationEmailAlarm19"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 4">
                    <v-select
                    v-model="covidConfiguration.companyAlarm19.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 4">
                    <v-text-field
                            name="correo20"
                            label="Correo 20 Notificación Alerta COVID"
                            id="correo20"
                            v-model="covidConfiguration.notificationEmailAlarm20"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 4">
                    <v-select
                    v-model="covidConfiguration.companyAlarm20.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 5">
                    <v-text-field
                            name="correo21"
                            label="Correo 21 Notificación Alerta COVID"
                            id="correo21"
                            v-model="covidConfiguration.notificationEmailAlarm21"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 5">
                    <v-select
                    v-model="covidConfiguration.companyAlarm21.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 5">
                    <v-text-field
                            name="correo22"
                            label="Correo 22 Notificación Alerta COVID"
                            id="correo22"
                            v-model="covidConfiguration.notificationEmailAlarm22"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 5">
                    <v-select
                    v-model="covidConfiguration.companyAlarm22.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 5">
                    <v-text-field
                            name="correo23"
                            label="Correo 23 Notificación Alerta COVID"
                            id="correo23"
                            v-model="covidConfiguration.notificationEmailAlarm23"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 5">
                    <v-select
                    v-model="covidConfiguration.companyAlarm23.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 5">
                    <v-text-field
                            name="correo24"
                            label="Correo 24 Notificación Alerta COVID"
                            id="correo24"
                            v-model="covidConfiguration.notificationEmailAlarm24"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 5">
                    <v-select
                    v-model="covidConfiguration.companyAlarm24.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 5">
                    <v-text-field
                            name="correo25"
                            label="Correo 25 Notificación Alerta COVID"
                            id="correo25"
                            v-model="covidConfiguration.notificationEmailAlarm25"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 5">
                    <v-select
                    v-model="covidConfiguration.companyAlarm25.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 6">
                    <v-text-field
                            name="correo26"
                            label="Correo 26 Notificación Alerta COVID"
                            id="correo26"
                            v-model="covidConfiguration.notificationEmailAlarm26"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 6">
                    <v-select
                    v-model="covidConfiguration.companyAlarm26.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 6">
                    <v-text-field
                            name="correo27"
                            label="Correo 27 Notificación Alerta COVID"
                            id="correo27"
                            v-model="covidConfiguration.notificationEmailAlarm27"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 6">
                    <v-select
                    v-model="covidConfiguration.companyAlarm27.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 6">
                    <v-text-field
                            name="correo28"
                            label="Correo 28 Notificación Alerta COVID"
                            id="correo28"
                            v-model="covidConfiguration.notificationEmailAlarm28"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 6">
                    <v-select
                    v-model="covidConfiguration.companyAlarm28.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 6">
                    <v-text-field
                            name="correo29"
                            label="Correo 29 Notificación Alerta COVID"
                            id="correo29"
                            v-model="covidConfiguration.notificationEmailAlarm29"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 6">
                    <v-select
                    v-model="covidConfiguration.companyAlarm29.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 6">
                    <v-text-field
                            name="correo30"
                            label="Correo 30 Notificación Alerta COVID"
                            id="correo30"
                            v-model="covidConfiguration.notificationEmailAlarm30"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 6">
                    <v-select
                    v-model="covidConfiguration.companyAlarm30.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 7">
                    <v-text-field
                            name="correo31"
                            label="Correo 31 Notificación Alerta COVID"
                            id="correo31"
                            v-model="covidConfiguration.notificationEmailAlarm31"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 7">
                    <v-select
                    v-model="covidConfiguration.companyAlarm31.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 7">
                    <v-text-field
                            name="correo32"
                            label="Correo 32 Notificación Alerta COVID"
                            id="correo32"
                            v-model="covidConfiguration.notificationEmailAlarm32"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 7">
                    <v-select
                    v-model="covidConfiguration.companyAlarm32.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 7">
                    <v-text-field
                            name="correo33"
                            label="Correo 33 Notificación Alerta COVID"
                            id="correo33"
                            v-model="covidConfiguration.notificationEmailAlarm33"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 7">
                    <v-select
                    v-model="covidConfiguration.companyAlarm33.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 7">
                    <v-text-field
                            name="correo34"
                            label="Correo 34 Notificación Alerta COVID"
                            id="correo34"
                            v-model="covidConfiguration.notificationEmailAlarm34"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 7">
                    <v-select
                    v-model="covidConfiguration.companyAlarm34.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 7">
                    <v-text-field
                            name="correo35"
                            label="Correo 35 Notificación Alerta COVID"
                            id="correo35"
                            v-model="covidConfiguration.notificationEmailAlarm35"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 7">
                    <v-select
                    v-model="covidConfiguration.companyAlarm35.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 8">
                    <v-text-field
                            name="correo36"
                            label="Correo 36 Notificación Alerta COVID"
                            id="correo36"
                            v-model="covidConfiguration.notificationEmailAlarm36"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 8">
                    <v-select
                    v-model="covidConfiguration.companyAlarm36.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 8">
                    <v-text-field
                            name="correo37"
                            label="Correo 37 Notificación Alerta COVID"
                            id="correo37"
                            v-model="covidConfiguration.notificationEmailAlarm37"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 8">
                    <v-select
                    v-model="covidConfiguration.companyAlarm37.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 8">
                    <v-text-field
                            name="correo38"
                            label="Correo 38 Notificación Alerta COVID"
                            id="correo38"
                            v-model="covidConfiguration.notificationEmailAlarm38"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 8">
                    <v-select
                    v-model="covidConfiguration.companyAlarm38.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 8">
                    <v-text-field
                            name="correo39"
                            label="Correo 39 Notificación Alerta COVID"
                            id="correo39"
                            v-model="covidConfiguration.notificationEmailAlarm39"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 8">
                    <v-select
                    v-model="covidConfiguration.companyAlarm39.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 8">
                    <v-text-field
                            name="correo40"
                            label="Correo 40 Notificación Alerta COVID"
                            id="correo40"
                            v-model="covidConfiguration.notificationEmailAlarm40"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 8">
                    <v-select
                    v-model="covidConfiguration.companyAlarm40.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 9">
                    <v-text-field
                            name="correo41"
                            label="Correo 41 Notificación Alerta COVID"
                            id="correo41"
                            v-model="covidConfiguration.notificationEmailAlarm41"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 9">
                    <v-select
                    v-model="covidConfiguration.companyAlarm41.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 9">
                    <v-text-field
                            name="correo42"
                            label="Correo 42 Notificación Alerta COVID"
                            id="correo42"
                            v-model="covidConfiguration.notificationEmailAlarm42"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 9">
                    <v-select
                    v-model="covidConfiguration.companyAlarm42.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 9">
                    <v-text-field
                            name="correo43"
                            label="Correo 43 Notificación Alerta COVID"
                            id="correo43"
                            v-model="covidConfiguration.notificationEmailAlarm43"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 9">
                    <v-select
                    v-model="covidConfiguration.companyAlarm43.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 9">
                    <v-text-field
                            name="correo44"
                            label="Correo 44 Notificación Alerta COVID"
                            id="correo44"
                            v-model="covidConfiguration.notificationEmailAlarm44"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 9">
                    <v-select
                    v-model="covidConfiguration.companyAlarm44.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 9">
                    <v-text-field
                            name="correo45"
                            label="Correo 45 Notificación Alerta COVID"
                            id="correo45"
                            v-model="covidConfiguration.notificationEmailAlarm45"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 9">
                    <v-select
                    v-model="covidConfiguration.companyAlarm45.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 10">
                    <v-text-field
                            name="correo46"
                            label="Correo 46 Notificación Alerta COVID"
                            id="correo46"
                            v-model="covidConfiguration.notificationEmailAlarm46"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 10">
                    <v-select
                    v-model="covidConfiguration.companyAlarm46.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 10">
                    <v-text-field
                            name="correo47"
                            label="Correo 47 Notificación Alerta COVID"
                            id="correo47"
                            v-model="covidConfiguration.notificationEmailAlarm47"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 10">
                    <v-select
                    v-model="covidConfiguration.companyAlarm47.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 10">
                    <v-text-field
                            name="correo48"
                            label="Correo 48 Notificación Alerta COVID"
                            id="correo48"
                            v-model="covidConfiguration.notificationEmailAlarm48"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 10">
                    <v-select
                    v-model="covidConfiguration.companyAlarm48.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 10">
                    <v-text-field
                            name="correo49"
                            label="Correo 49 Notificación Alerta COVID"
                            id="correo49"
                            v-model="covidConfiguration.notificationEmailAlarm49"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 10">
                    <v-select
                    v-model="covidConfiguration.companyAlarm49.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>
                <v-flex xs12 sm4 d-flex offset-sm1 v-if="page == 10">
                    <v-text-field
                            name="correo50"
                            label="Correo 50 Notificación Alerta COVID"
                            id="correo50"
                            v-model="covidConfiguration.notificationEmailAlarm50"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 d-flex v-if="page == 10">
                    <v-select
                    v-model="covidConfiguration.companyAlarm50.id"
                    :items="$store.state.companies"
                    label="Cliente"
                    item-value="id"
                    item-text="name"
                    ></v-select>
                </v-flex>                
                <v-flex xs12 sm10 d-flex>
                    <div class="text-xs-center">
                        <v-pagination
                        v-model="page"
                        :length="10"
                        circle
                        ></v-pagination>
                    </div>
                </v-flex>                
            </v-layout>            
            <br>            
            <v-layout>
                <v-flex xs12 sm3 offset-sm1>
                    <p class="font-weight-bold">Recordatorio de llenar formulario de alerta 1 hora antes:</p>
                    <v-select
                            v-model="covidConfiguration.reminderAlarm1"
                            :items="this.itemsElements"
                            item-text="name"
                            item-value="id"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm3 offset-sm1>
                    <p class="font-weight-bold">Recordatorio de llenar formulario de alerta 4 hora antes:</p>
                    <v-select
                            v-model="covidConfiguration.reminderAlarm2"
                            :items="this.itemsElements"
                            item-text="name"
                            item-value="id"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm3 offset-sm1>
                    <p class="font-weight-bold">Encriptar Reportes</p>
                    <v-select
                            v-model="covidConfiguration.encryptReport"
                            :items="this.itemsElements"
                            item-text="name"
                            item-value="id"
                            return-object
                            required
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm3 offset-sm1>
                    <v-btn @click="getCovidPatientDoctorAsistantReport" small color="secondary">
                        Generar reporte Médico paciente
                        <v-icon right dark>cloud_download</v-icon>
                    </v-btn>
                </v-flex>
            </v-layout>

            <v-layout>
                <v-flex xs12 sm6 offset-sm4>
                    <div>
                        <v-btn :disabled="!valid"
                               @click="saveData" large color="primary">Guardar
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-form>
        <v-dialog
                v-model="dialogDownloadReportAlarm"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Reporte generado exitosamente.</span>
                </v-card-title>
                <div align="center">
                    <a :href="urlDownloadReport">Descargar Reporte</a>
                </div>

                <v-card-actions>
                    <br>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogDownloadReportAlarm = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
    import CovidConfiguration from "../../model/CovidConfiguration";

    export default {
        data() {
            return {
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                statusItems: ['ACTIVO',
                    'INACTIVO'],
                headers: [
                    {text: 'Identificacion', value: 'identification'},
                    {text: 'Nombre', value: 'name'},
                    {text: 'Apellido', value: 'lastName'},
                    {text: 'Compañia', value: 'company.name'},
                    {text: 'Estado', value: 'status'},
                    {text: 'Opciones', value: 'options'},
                    {text: 'Alarmas', value: 'alarm'}


                ],
                itemsElements: ['SI', 'NO'],
                editedIndex: -1,
                covidConfiguration: new CovidConfiguration(),
                alert: false,
                page: 1,
                urlDownloadReport:"",
                dialogDownloadReportAlarm: false,
            };
        },
        methods: {
            cleanData() {
                this.$refs.form.reset();
                this.valid = false;
                this.dialog = false;
            },
            saveData() {
                if (this.$refs.form.validate()) {
                    var llenarDatos = false; 
                    if (this.covidConfiguration.companyAlarm1.id != ''
                        && this.covidConfiguration.notificationEmailAlarm1 === '') {
                            llenarDatos = true;
                    }
                    if (this.covidConfiguration.companyAlarm2.id != ''
                        && this.covidConfiguration.notificationEmailAlarm2 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm3.id != ''
                        && this.covidConfiguration.notificationEmailAlarm3 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm4.id != ''
                        && this.covidConfiguration.notificationEmailAlarm4 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm5.id != ''
                        && this.covidConfiguration.notificationEmailAlarm5 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm6.id != ''
                        && this.covidConfiguration.notificationEmailAlarm6 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm7.id != ''
                        && this.covidConfiguration.notificationEmailAlarm7 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm8.id != ''
                        && this.covidConfiguration.notificationEmailAlarm8 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm9.id != ''
                        && this.covidConfiguration.notificationEmailAlarm9 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm10.id != ''
                        && this.covidConfiguration.notificationEmailAlarm10 === '') {
                            llenarDatos = true;
                    }
                    if (this.covidConfiguration.companyAlarm11.id != ''
                        && this.covidConfiguration.notificationEmailAlarm11 === '') {
                            llenarDatos = true;
                    }
                    if (this.covidConfiguration.companyAlarm12.id != ''
                        && this.covidConfiguration.notificationEmailAlarm12 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm13.id != ''
                        && this.covidConfiguration.notificationEmailAlarm13 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm14.id != ''
                        && this.covidConfiguration.notificationEmailAlarm14 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm15.id != ''
                        && this.covidConfiguration.notificationEmailAlarm15 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm16.id != ''
                        && this.covidConfiguration.notificationEmailAlarm16 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm17.id != ''
                        && this.covidConfiguration.notificationEmailAlarm17 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm18.id != ''
                        && this.covidConfiguration.notificationEmailAlarm18 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm19.id != ''
                        && this.covidConfiguration.notificationEmailAlarm19 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm20.id != ''
                        && this.covidConfiguration.notificationEmailAlarm20 === '') {
                            llenarDatos = true;
                    }
                    if (this.covidConfiguration.companyAlarm21.id != ''
                        && this.covidConfiguration.notificationEmailAlarm21 === '') {
                            llenarDatos = true;
                    }
                    if (this.covidConfiguration.companyAlarm22.id != ''
                        && this.covidConfiguration.notificationEmailAlarm22 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm23.id != ''
                        && this.covidConfiguration.notificationEmailAlarm23 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm24.id != ''
                        && this.covidConfiguration.notificationEmailAlarm24 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm25.id != ''
                        && this.covidConfiguration.notificationEmailAlarm25 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm26.id != ''
                        && this.covidConfiguration.notificationEmailAlarm26 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm27.id != ''
                        && this.covidConfiguration.notificationEmailAlarm27 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm28.id != ''
                        && this.covidConfiguration.notificationEmailAlarm28 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm29.id != ''
                        && this.covidConfiguration.notificationEmailAlarm29 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm30.id != ''
                        && this.covidConfiguration.notificationEmailAlarm30 === '') {
                            llenarDatos = true;
                    }
                    if (this.covidConfiguration.companyAlarm31.id != ''
                        && this.covidConfiguration.notificationEmailAlarm31 === '') {
                            llenarDatos = true;
                    }
                    if (this.covidConfiguration.companyAlarm32.id != ''
                        && this.covidConfiguration.notificationEmailAlarm32 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm33.id != ''
                        && this.covidConfiguration.notificationEmailAlarm33 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm34.id != ''
                        && this.covidConfiguration.notificationEmailAlarm34 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm35.id != ''
                        && this.covidConfiguration.notificationEmailAlarm35 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm36.id != ''
                        && this.covidConfiguration.notificationEmailAlarm36 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm37.id != ''
                        && this.covidConfiguration.notificationEmailAlarm37 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm38.id != ''
                        && this.covidConfiguration.notificationEmailAlarm38 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm39.id != ''
                        && this.covidConfiguration.notificationEmailAlarm39 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm40.id != ''
                        && this.covidConfiguration.notificationEmailAlarm40 === '') {
                            llenarDatos = true;
                    }
                    if (this.covidConfiguration.companyAlarm41.id != ''
                        && this.covidConfiguration.notificationEmailAlarm41 === '') {
                            llenarDatos = true;
                    }
                    if (this.covidConfiguration.companyAlarm42.id != ''
                        && this.covidConfiguration.notificationEmailAlarm42 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm43.id != ''
                        && this.covidConfiguration.notificationEmailAlarm43 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm44.id != ''
                        && this.covidConfiguration.notificationEmailAlarm44 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm45.id != ''
                        && this.covidConfiguration.notificationEmailAlarm45 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm46.id != ''
                        && this.covidConfiguration.notificationEmailAlarm46 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm47.id != ''
                        && this.covidConfiguration.notificationEmailAlarm47 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm48.id != ''
                        && this.covidConfiguration.notificationEmailAlarm48 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm49.id != ''
                        && this.covidConfiguration.notificationEmailAlarm49 === '') {
                            llenarDatos = true;
                    } 
                    if (this.covidConfiguration.companyAlarm50.id != ''
                        && this.covidConfiguration.notificationEmailAlarm50 === '') {
                            llenarDatos = true;
                    }
                    if (llenarDatos) {
                        this.$store.state.dialogError = true;
                        this.$store.state.dialogErrorMessage = 'Se debe asociar una empresa con un correo electrónico.';
                    } else if (this.editedIndex > -1) {
                        this.$store.dispatch('updateCovidConfiguration', this.covidConfiguration).then(
                            response => {
                                this.loadData();
                                this.alert = true;
                                this.$vuetify.goTo(0);
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                                this.$store.state.dialogErrorMessage = 'No se pudo modificar la configuración verifique la información'
                            }
                        );
                    } else {
                        this.$store.dispatch('addCovidConfiguration', this.covidConfiguration).then(
                            response => {
                                this.loadData();
                                this.alert = true;
                                this.$vuetify.goTo(0);
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                                this.$store.state.dialogErrorMessage = 'No se pudo crear la configuración verifique que no exista'
                            }
                        );
                    }
                    this.dialog = false;                    
                }
            },
            loadData() {
                this.$store.dispatch('getCovidConfiguration').then(
                    response => {                        
                        if (response.data.id != null) {
                            this.covidConfiguration = response.data;                            
                            if (this.covidConfiguration.companyAlarm1 == null) {
                                this.covidConfiguration.companyAlarm1 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm2 == null) {
                                this.covidConfiguration.companyAlarm2 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm3 == null) {
                                this.covidConfiguration.companyAlarm3 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm4 == null) {
                                this.covidConfiguration.companyAlarm4 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm5 == null) {
                                this.covidConfiguration.companyAlarm5 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm6 == null) {
                                this.covidConfiguration.companyAlarm6 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm7 == null) {
                                this.covidConfiguration.companyAlarm7 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm8 == null) {
                                this.covidConfiguration.companyAlarm8 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm9 == null) {
                                this.covidConfiguration.companyAlarm9 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm10 == null) {
                                this.covidConfiguration.companyAlarm10 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm11 == null) {
                                this.covidConfiguration.companyAlarm11 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm12 == null) {
                                this.covidConfiguration.companyAlarm12 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm13 == null) {
                                this.covidConfiguration.companyAlarm13 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm14 == null) {
                                this.covidConfiguration.companyAlarm14 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm15 == null) {
                                this.covidConfiguration.companyAlarm15 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm16 == null) {
                                this.covidConfiguration.companyAlarm16 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm17 == null) {
                                this.covidConfiguration.companyAlarm17 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm18 == null) {
                                this.covidConfiguration.companyAlarm18 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm19 == null) {
                                this.covidConfiguration.companyAlarm19 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm20 == null) {
                                this.covidConfiguration.companyAlarm20 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm21 == null) {
                                this.covidConfiguration.companyAlarm21 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm22 == null) {
                                this.covidConfiguration.companyAlarm22 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm23 == null) {
                                this.covidConfiguration.companyAlarm23 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm24 == null) {
                                this.covidConfiguration.companyAlarm24 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm25 == null) {
                                this.covidConfiguration.companyAlarm25 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm26 == null) {
                                this.covidConfiguration.companyAlarm26 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm27 == null) {
                                this.covidConfiguration.companyAlarm27 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm28 == null) {
                                this.covidConfiguration.companyAlarm28 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm29 == null) {
                                this.covidConfiguration.companyAlarm29 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm30 == null) {
                                this.covidConfiguration.companyAlarm30 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm31 == null) {
                                this.covidConfiguration.companyAlarm31 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm32 == null) {
                                this.covidConfiguration.companyAlarm32 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm33 == null) {
                                this.covidConfiguration.companyAlarm33 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm34 == null) {
                                this.covidConfiguration.companyAlarm34 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm35 == null) {
                                this.covidConfiguration.companyAlarm35 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm36 == null) {
                                this.covidConfiguration.companyAlarm36 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm37 == null) {
                                this.covidConfiguration.companyAlarm37 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm38 == null) {
                                this.covidConfiguration.companyAlarm38 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm39 == null) {
                                this.covidConfiguration.companyAlarm39 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm40 == null) {
                                this.covidConfiguration.companyAlarm40 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm41 == null) {
                                this.covidConfiguration.companyAlarm41 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm42 == null) {
                                this.covidConfiguration.companyAlarm42 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm43 == null) {
                                this.covidConfiguration.companyAlarm43 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm44 == null) {
                                this.covidConfiguration.companyAlarm44 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm45 == null) {
                                this.covidConfiguration.companyAlarm45 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm46 == null) {
                                this.covidConfiguration.companyAlarm46 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm47 == null) {
                                this.covidConfiguration.companyAlarm47 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm48 == null) {
                                this.covidConfiguration.companyAlarm48 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm49 == null) {
                                this.covidConfiguration.companyAlarm49 = {id: ""};
                            }
                            if (this.covidConfiguration.companyAlarm50 == null) {
                                this.covidConfiguration.companyAlarm50 = {id: ""};
                            }
                            this.editedIndex = 0;
                        } else {
                            this.covidConfiguration = new CovidConfiguration();
                            this.editedIndex = -1;
                        }
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                );
            },
            getCovidPatientDoctorAsistantReport() {
                this.$store.dispatch('generateDoctorAsistantReport').then(response => {
                    this.$store.state.progress = false;
                    this.urlDownloadReport = response.data
                    this.dialogDownloadReportAlarm = true
                })
            },

        },
        computed: {},
        created() {
            this.$store.dispatch('getCompanies').then(response => {                
            }, error => {
                this.$store.state.dialogError = true
            });            
            if (this.$store.state.companies) {
                this.$store.state.companies.push({id: '', name: 'TODOS'});
            }
            this.loadData()

        }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/covid/CovidConfiguration.vue